import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import { css, ThemeProvider } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { Button } from "src/components/Button/Button.tsx";
import { EmptyState } from "src/components/EmptyState/EmptyState.tsx";

type Props = {
  onReload?: () => void;
};

export const DataGridErrorOverlay = ({ onReload }: Props) => {
  const theme = useNonConflictingTheme();
  const { t } = useTranslation(TranslationNamespaceEnum.DataGridComponent);

  return (
    <ThemeProvider theme={theme}>
      <EmptyState
        css={rootStyles}
        title={t("errorOverlay.title")}
        type={"warning"}
        action={
          <Button size={"sm"} onClick={onReload} variant="filled" skin="info">
            {t("errorOverlay.action")}
          </Button>
        }
      />
    </ThemeProvider>
  );
};

const rootStyles = css`
  height: 100%;
  width: 100%;
`;
